import { useEffect, useState } from 'react';

type StorageType = 'localstorage' | 'sessionstorage';

/**
 * useState wrapper using LocalStorage
 * @param key localStorage item's key
 * @param defaultValue fallback value if value isn't available
 * @returns
 */
export function useLocalStorage<T>(
  key: string,
  defaultValue: T,
  storageType: StorageType = 'localstorage'
): [T, (param: T) => void] {
  const storage = storageType === 'localstorage' ? localStorage : sessionStorage;

  // Explicit cast to T
  const [state, setState] = useState<T>(
    (JSON.parse(storage.getItem(key) ?? 'null') as T) ?? defaultValue
  );

  const localSetState = (value: T) => {
    setState(value);
    storage.setItem(key, JSON.stringify(value));
  };

  // Update state if key changed
  useEffect(() => {
    setState((JSON.parse(storage.getItem(key) ?? 'null') as T) ?? defaultValue);
  }, [key]);

  return [state, localSetState];
}
